import { NavLink } from 'react-router-dom';

const TABS: ReadonlyArray<{ to: string; label: string }> = [
  { to: '/admin/email/senders', label: 'Remitentes' },
  { to: '/admin/email/templates', label: 'Plantillas' },
  { to: '/admin/email/rules', label: 'Reglas' },
];

/** Shared sub-navigation across the three email-alert admin pages. */
export function EmailAlertAdminTabs(): JSX.Element {
  return (
    <nav className="flex gap-2 border-b border-slate-200">
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          className={({ isActive }) =>
            'px-3 py-2 text-sm font-medium transition-colors ' +
            (isActive ? 'border-b-2 border-primary text-primary' : 'text-slate-600 hover:text-slate-900')
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
